module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/service-items/service-items-grid/service-items-grid.component.css
// module id = ./src/app/components/service-items/service-items-grid/service-items-grid.component.css
// module chunks = main